import React from "react";
import { useTranslation } from "react-i18next";
import NotFoudImg from "./../../assets/img/banner-section.png";
import Seo from "../../shared/seo/Seo";
import { copy, currentLang } from "../../shared/seo/links";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <center style={{ marginRight: "20px", marginLeft: "20px" }}>
      <Seo noindex title={copy.page(currentLang(), "notFound").title} />
      <img
        style={{
          margin: "20px",
        }}
        src={NotFoudImg}
        width={"300px"}
        alt=""
      />
      <h1>{t("not_found_title")}</h1>
      <p>{t("not_found_text")}</p>
      <br></br>
      <br></br>
      <br></br>
    </center>
  );
}
